
import { COUNTRIES, POPULAR_COUNTRIES, type Country, type CountryCode } from './country-data';

// Create a map for fast lookups
const COUNTRY_MAP = new Map(COUNTRIES.map(country => [country.code, country]));

// Get country by ISO code
export function getCountryByCode(code: string): Country | undefined {
  return COUNTRY_MAP.get(code as CountryCode);
}

// Get country display name by ISO code
export function getCountryDisplayName(code: string): string {
  const country = getCountryByCode(code);
  return country ? country.name : code;
}

// Get all countries for dropdown
export function getCountryOptions() {
  return [
    { value: '', label: 'All Countries' },
    ...COUNTRIES.map(country => ({
      value: country.code,
      label: country.name
    }))
  ];
}

// Get popular countries for priority display
export function getPopularCountryOptions() {
  const popularCountries = POPULAR_COUNTRIES.map(code => 
    COUNTRY_MAP.get(code)
  ).filter(Boolean) as Country[];

  return [
    { value: '', label: 'All Countries' },
    ...popularCountries.map(country => ({
      value: country.code,
      label: country.name
    }))
  ];
}

// Get countries by region
export function getCountriesByRegion(region: string): Country[] {
  return COUNTRIES.filter(country => country.region === region);
}

// Search countries by name
export function searchCountries(query: string): Country[] {
  const searchTerm = query.toLowerCase();
  return COUNTRIES.filter(country => 
    country.name.toLowerCase().includes(searchTerm) ||
    country.code.toLowerCase().includes(searchTerm)
  );
}

// Validate country code
export function isValidCountryCode(code: string): code is CountryCode {
  return COUNTRY_MAP.has(code as CountryCode);
}

export { COUNTRIES, POPULAR_COUNTRIES };
export type { Country, CountryCode };
